/* start - FLIGHTS_WEB_CHECKOUT_BACK_RESET_CART */
import { flightsLocalStore } from "@flights/web-api-utils-universal";

type CheckoutStatus = {
  requiresCartReset?: boolean;
  redirectToStart?: boolean;
  hasSkippedExtras?: boolean;
};

const key = "checkout_status";
const expirationTime = "30m";

export const getAllCheckoutStatus = () => (flightsLocalStore.get(key) || {}) as CheckoutStatus;

export const getCheckoutStatus = (type: keyof CheckoutStatus) => {
  const checkoutStatus = getAllCheckoutStatus();
  return checkoutStatus[type];
};

export const getCheckoutStatusWithFallback = (type: keyof CheckoutStatus) => {
  const checkoutStatus = getAllCheckoutStatus();

  // At Checkout start the status properties are all reset (set to false).
  // This guarantees the properties are always existent, if for some reason
  // the properties do not exist (maybe the user deleted storage), we will
  // consider the value as "true" to force whatever side effects and avoid
  // issues during the checkout flow.
  if (type in checkoutStatus) {
    return checkoutStatus[type];
  }

  return true;
};

const setCheckoutStatus = (type: keyof CheckoutStatus, status: boolean) => {
  const currentData = getAllCheckoutStatus();
  flightsLocalStore.set(key, { ...currentData, [type]: status }, { ttl: expirationTime });
};

export const enableCheckoutStatus = (type: keyof CheckoutStatus) => {
  setCheckoutStatus(type, true);
};

export const disableCheckoutStatus = (type: keyof CheckoutStatus) => {
  setCheckoutStatus(type, false);
};

export const resetCheckoutStatus = () => {
  flightsLocalStore.unset(key); // Making sure we get rid of deprecated properties

  const statuses: Array<keyof CheckoutStatus> = ["requiresCartReset"];

  statuses.forEach((s) => disableCheckoutStatus(s));
};
/* end - FLIGHTS_WEB_CHECKOUT_BACK_RESET_CART  */
